import useTheme from "../../../../common/hooks/useTheme";
import { userStatus } from "../../store/helper";

const StatusBadge = ({ status }: { status: number }) => {
  const theme = useTheme();

  const getStatusColor = (type: number) => {
    if (type === userStatus.Completed) {
      return theme.colorTokens.S[70];
    } else if (type === userStatus.Pending) {
      return theme.colorTokens.W[80];
    } else if (type === userStatus.InProgress) {
      return theme.colors_ds.PRIMARY_ICON_MAIN;
    } else {
      return theme.colors_ds.NEUTRAL_ICON_WEAK;
    }
  };
  return (
    <div style={styles.cardStatusContainer(theme, getStatusColor(status))}>
      <div style={styles.cardStatusDot(theme, getStatusColor(status))} />
      <div style={styles.cardStatusText(theme)}>
        {status === userStatus.Completed
          ? "Completed"
          : status === userStatus.Pending
          ? "Pending"
          : status === userStatus.InProgress
          ? "In progress"
          : "None"}
      </div>
    </div>
  );
};

export default StatusBadge;

const styles = {
  cardStatusContainer: (theme: any, statusColor: string) => ({
    padding: "4px 8px",
    borderRadius: "8px",
    border: `1px solid ${statusColor}`,
    display: "flex",
    alignItems: "center",
    gap: "8px",
    maxWidth: "200px",
  }),
  cardStatusDot: (theme: any, statusColor: string) => ({
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    backgroundColor: statusColor,
  }),
  cardStatusText: (theme: any) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "12px",
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
  }),
};
